import { localeOption } from 'primereact/api';
import { Ru } from './locales/ru';
import { En } from './locales/en';

const localeOptionWithCurrentLocale = <T extends Ru | En, K extends keyof T>(key: K, locale = ''): T[K] =>
  localeOption(key as string, locale);

export { localeOptionWithCurrentLocale as localeOption };
